import {Injectable} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {erIkkeNil, erNil} from "../støttefunksjoner/nilsjekk";
import {Temporal} from "temporal-polyfill";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {GjeldendeTidssone, Tidssoneinformasjon} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";
import {PlainDateFormat, TemporalFormatering} from "./TemporalFormatering";
import {ZonedDateTimePeriodeLukket, ZonedDateTimePeriodeMuligÅpenSlutt} from "felles-ng2/typer/ZonedDateTimePeriode";
import ZonedDateTime = Temporal.ZonedDateTime;

const debug = initDebugger('DatoPeriodeFormatering');

/**
 * Tjeneste for formatering av {@link ZonedDateTimePeriode}.
 */
@Injectable()
export class DatoPeriodeFormatering {

    constructor(private temporalFormatering: TemporalFormatering, private gjeldendeTidssone: GjeldendeTidssone, private oversettelser: Oversettelser) {
    }

    /**
     * Formaterer angitt periode som '<start> til <slutt>'
     * Bruker 'short' som standard formatering av dato, eks '11.07.2014, 12:01 til 13.08.2014, 12:01'
     */
    formater(periode: ZonedDateTimePeriodeLukket | null, format: PlainDateFormat = 'short', tidssone: Tidssoneinformasjon = this.gjeldendeTidssone.brukersTidssone()): string {
       return this.formaterMuligÅpenSlutt(periode, format, tidssone);
    }

    /**
     * Formaterer angitt periode som '<start> til <slutt>', med støtte for åpen slutt-dato.
     * Bruker 'short' som standard formatering av dato, eks '11.07.2014, 12:01 til (slutt ikke angitt)'
     */
    formaterMuligÅpenSlutt(periode: ZonedDateTimePeriodeMuligÅpenSlutt | null, format: PlainDateFormat = 'short', tidssone: Tidssoneinformasjon = this.gjeldendeTidssone.brukersTidssone()): string {
        if (erNil(periode)) return '';

        const datoSomStreng = (dato: ZonedDateTime) => {
            return this.temporalFormatering.formaterZonedDateTime(dato, format, false, tidssone.somZoneId());
        }

        const startSomStreng = datoSomStreng(periode.start);
        let sluttSomStreng = this.oversettelser.oversett(i18n('(slutt ikke angitt)'));
        if (erIkkeNil(periode.slutt)) sluttSomStreng = datoSomStreng(periode.slutt);
        const til = this.oversettelser.oversett(i18n('til'))

        return `${startSomStreng} ${til} ${sluttSomStreng}`;
    }

    //hjelpemetoder

}
